import { render, staticRenderFns } from "./uexccTypeAdd.vue?vue&type=template&id=25fb6d4f"
import script from "./uexccTypeAdd.vue?vue&type=script&lang=js"
export * from "./uexccTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./uexccTypeAdd.vue?vue&type=style&index=0&id=25fb6d4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports